import hasAuthor from './utilities/hasAuthor';
import hasCapitalizedFields from './utilities/hasCapitalizedFields';
import hasOit from './utilities/hasOit';
import hasTask from './utilities/hasTask';

const taskResponse = (taskResponseJson) => {
  const properties = {
    ...taskResponseJson.attributes,
    guid: taskResponseJson.guid,
  };
  return Object.assign(
    properties,
    hasAuthor(taskResponseJson.attributes.author),
    hasCapitalizedFields(taskResponseJson.attributes),
    hasOit(taskResponseJson.attributes.oit),
    hasTask(taskResponseJson.attributes.task),
  );
};

export default taskResponse;
